module.exports = __webpack_public_path__ + "img/2_177.f8aeec58.png";